import React from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { NAVIGATION_PATHS, homeToken } from "../../utils/constant";
import { redirectToConnectHome, stripTrailingSlash } from "../../utils/config";
import {
  HeaderNavigationBox,
  HeaderNavigationLink,
  HeaderNavigationText,
  HeaderNavigationHomeIcon,
  StyledNavigationArrow
} from "./HeaderNavigation.styles";
import { useSelector } from "react-redux";

const NavigationPage = ({strippedPathname , isHeaderShrink}) => {
  const { t } = useTranslation();
  
  return (
    <>
      {Object.entries(NAVIGATION_PATHS).map(([key, value]) => {
        if (key !== "Connections" && (strippedPathname === value)) {
          return (
            <React.Fragment key={key}>
              <StyledNavigationArrow isHeaderShrink={isHeaderShrink}/>
              <HeaderNavigationText
                isbold="true"
                key={key}
              >
                {t(homeToken[key])}
              </HeaderNavigationText>
             
            </React.Fragment>
          );
        }
      })}
    </>
  );
};

const HeaderNavigation = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const strippedPathname = stripTrailingSlash(location.pathname);
  const isHeaderShrink = useSelector(state=>state.header.isHeaderShrink);

  return (
    <HeaderNavigationBox isHeaderShrink={isHeaderShrink}>
      <HeaderNavigationHomeIcon onClick={redirectToConnectHome} isHeaderShrink={isHeaderShrink}/>
      <StyledNavigationArrow isHeaderShrink={isHeaderShrink} />
      <HeaderNavigationText isbold="false" >{t(homeToken.MyNetwork)}</HeaderNavigationText>
      <StyledNavigationArrow isHeaderShrink={isHeaderShrink} />
      <HeaderNavigationLink
        isbold={strippedPathname === NAVIGATION_PATHS.Connections?"true":"false"}
        to={NAVIGATION_PATHS.Connections}
      >{t(homeToken.Connections)}</HeaderNavigationLink>
      <NavigationPage strippedPathname={strippedPathname} isHeaderShrink={isHeaderShrink} />
    </HeaderNavigationBox>
  );
};

export default HeaderNavigation;
